import {
  NO_INTERNET_ERROR_MESSAGE,
  SERVER_ERROR_MESSAGE,
  STATUS_CODE_ZERO,
  UNKNOWN_ERROR_MESSAGE
} from "../values";

interface IErrorResponse {
  page?: string;
  statusCode: number;
  message: string;
}

const errorResponses: IErrorResponse[] = [
  {
    statusCode: 0, // it could be CORS, etc
    message: STATUS_CODE_ZERO
  },

  // Client Errors
  {
    statusCode: 400, // bad request
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 401, // unauthorized
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 402, // payment required
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 403, // forbidden
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 404, // not found
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 405, // method not allowed
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 406, // not acceptable
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 407, // proxy authentication required
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 408, // request timeout
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 409, // conflict
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 410, // gone
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 411, // length required
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 412, // preconditional failed
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 413, // request entity too large
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 414, // request uri too long
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 415, // unsupported medida type
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 416, // requested range not satisfiable
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 417, // expectation failed
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 426, // upgrade required
    message: SERVER_ERROR_MESSAGE
  },

  // Server Errors
  {
    statusCode: 500, // internal server
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 501, // not implemented
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 502, // bad gateway
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 503, // service unavailable
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 504, // gateway timeout
    message: SERVER_ERROR_MESSAGE
  },
  {
    statusCode: 505, // http version not supported
    message: SERVER_ERROR_MESSAGE
  },
];

export const errorCodeHandlerResponse = (statusCode: number, page?: string): string => {
  const error = errorResponses.find(
    error => error.page === page &&
    error.statusCode === statusCode
  );
  return error ? error.message : UNKNOWN_ERROR_MESSAGE;
}
